import "./App.css";
import Dock from "./components/Dock";
import Desktop from "./components/Desktop";
import StartScreen from "./components/StartScreen";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import MobileHome from "./components/Mobile/MobileHome";
import { Toaster } from "sonner";
function App() {
  const { show } = useSelector((state) => state.start);

  const [isMobile, setIsMobile] = useState(-1);

  const handleResize = () => {
    if (window.innerWidth < 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="">
      <Toaster
        position={isMobile === true ? "top-center" : "top-right"}
        offset={isMobile === true ? 12 : 40}
        toastOptions={{ className: `notification-shell ${isMobile === true ? "notification-shell--dark" : ""}` }}
      />
      {isMobile === -1 && <div className="w-screen h-screen bg-black"></div>}
      {isMobile === true && (
        <>
          {show && <StartScreen device="iPhone" />}
          <MobileHome />
        </>
      )}
      {isMobile === false && (
        <div className="w-screen h-screen wallpaper-mac">
          {show && <StartScreen device="Mac" />}
          <Desktop />
          <Dock />
        </div>
      )}
    </div>
  );
}

export default App;
